import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { appReducer } from './reducers/AppReducer';
import { rootSaga } from './sagas/RootSaga';
import { AppState } from './state/AppState';

export function initAppStore() {
  const sagaMiddleware = createSagaMiddleware();

  // Redux Dev Tools support docs: https://github.com/zalmoxisus/redux-devtools-extension#usage
  const composeEnhancers = composeWithDevTools({
    maxAge: 200,
  });

  const store: Store<AppState> = createStore(appReducer, composeEnhancers(
    applyMiddleware(sagaMiddleware)
  ));

  sagaMiddleware.run(rootSaga as any);

  return store;
}

export const appStore = initAppStore();
